<!-- content begin -->
<div id="content" class="no-bottom no-top">
    <div id="top"></div>


    <!-- section begin -->
    <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)"
        data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; ">
        <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>About the post</h1>
                    </div>
                </div>
            </div>

        </div>

    </section>
    <!-- section close -->



    <div class="row notifi_main ">
        <div class="col-md-12">
            <h2>
                Content Writer at NIMI Organization
            </h2>

            <p class="para_main_notify">
                NIMI Organization is seeking a talented and driven Content Writer to develop and distribute compelling content that aligns with our marketing and communications objectives. The ideal candidate will collaborate with our marketing, design, and product teams to produce content that strengthens our brand’s online presence, engages our audience, and drives conversion.
            </p>
        </div>
    </div>


    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
                <div class="col-md-12">
                    <div class="row sequence">

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Responsibilities::</h3>

                                    <p><span class="step_no">1</span>Write and deliver high-quality written content across various platforms, including blogs, social media, email campaigns, and newsletters</p>
                                    <p><span class="step_no">2</span>Edit, proofread, and ensure clarity, grammar, and style consistency while maintaining the brand voice</p>
                                    <p><span class="step_no">3</span>Collaborate with designers, video editors, and other content creators to produce multimedia content (images, videos, etc.)</p>
                                    <p><span class="step_no">4</span>Conduct keyword research and implement SEO best practices to enhance content visibility on search engines</p>
                                    <p><span class="step_no">5</span>Monitor content performance using analytics tools and refine strategies to increase engagement and effectiveness</p>
                                    <p><span class="step_no">6</span>Manage the content calendar to ensure timely delivery of blog posts, articles, and other written materials</p>
                                    <p><span class="step_no">7</span>Support the creation of additional content, such as e-commerce descriptions, landing pages, and marketing copy for digital ads</p>
                                    <p><span class="step_no">8</span>Stay up-to-date with industry trends and content marketing best practices to innovate and improve content strategies</p>
                                    
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-cogs"></i>
                                <div class="text para_cls">
                                    <h3>Skills and Qualifications:</h3>
                                    <p><span class="step_no">1</span>Proven experience in writing and editing content, with a strong portfolio of published work </p>
                                    <p><span class="step_no">2</span>Knowledge of SEO principles and digital marketing techniques to optimize content for search engines </p>
                                    <p><span class="step_no">3</span>Exceptional writing and storytelling abilities, with the ability to produce clear, engaging, and persuasive content </p>
                                    <p><span class="step_no">4</span> Familiarity with content management systems, such as WordPress, for publishing and updating content </p>
                                    <p><span class="step_no">5</span>Strong time management skills, with the ability to handle multiple projects and meet deadlines in a fast-paced environment </p>
                                    <p><span class="step_no">6</span> Ability to adapt content for different audiences and platforms while maintaining the brand’s voice </p>
                                    <p><span class="step_no">7</span> Experience with content creation tools (e.g., Google Analytics, SEO tools, Microsoft Office Suite, etc.) </p>
                                    <p><span class="step_no">8</span> Strong collaboration and communication skills to work effectively with cross-functional teams (designers, editors, marketers, etc.)</p>
                                    <p><span class="step_no">9</span> Experience in B2B or nonprofit content creation is a plus</p>
                                    <p><span class="step_no">10</span> Familiarity with graphic design software or video editing tools is beneficial but not required</p>


                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-graduation-cap"></i>
                                <div class="text para_cls">
                                    <h3>Education and Training Requirements: </h3>
                                    <p> <span class="step_no">1</span> Bachelor's degree in Marketing, Communications, Journalism, or a related field preferred, or a strong portfolio showcasing successful content writing projects </p>
                                    <!-- <p> <span class="step_no">2</span> To develop, write and disseminate media related
                                        items such as media advisories and news releases, speeches and briefing notes
                                        for senior officers and management. </p> -->
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->


                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Experience Requirements: </h3>
                                    <p> <span class="step_no">1</span>At least two years of experience in content writing or a related field, ideally in a fast-paced work environment, such as an agency or large organization </p>
                                    <!-- <p> <span class="step_no">2</span> A graduation in post-graduation in relevant field
                                        /business administration. </p> -->

                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->




                        <!-- feature box begin -->
                        <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-history"></i>
                                <div class="text para_cls">
                                    <h3>Experience:</h3>
                                    <p> At-least 8+ years of experience in the field of
                                        communication with Bachelor of Journalism & Mass Communication. A
                                        post-graduation in relevant field / business administration is desirable
                                        qualification. The experience of working in the field of vocational training
                                        would be preferred qualification.
                                    </p>
                                </div>
                            </div>
                        </div> -->
                        <!-- feature box close -->


                        <!-- feature box begin -->
                        <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-money"></i>
                                <div class="text para_cls">
                                    <h3>Remuneration:</h3>
                                    <p> Remuneration range in ₹ 70,000 - 1,00,000 depending on the experience and last pay
                                        drawn salary.
                                    </p>
                                </div>
                            </div>
                        </div> -->
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calendar"></i>
                                <div class="text para_cls">
                                    <h3>Last Date:</h3>
                                    <p style="color: red;"><b> Last date for Applying Online 30th December 2024 </b> </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        

                        <!-- feature box begin -->
                        <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-globe"></i>
                                <div class="text para_cls">
                                    <h3>Nature of engagement:</h3>
                                    <p><span class="step_no">1</span> Initial engagement shall be for three months with
                                        further extension of contract as per project timeline.</p>


                                </div>
                            </div>
                        </div> -->
                        <!-- feature box close -->

                        <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div>


                    </div>
                    <!-- content close -->




                    <style>
                        #section-intro {
                            background-image: url(assets/images/background/niminew.jpg);
                            background-size: cover;
                            background-position: 0% 0px;
                            height: 80vh !important;
                        }

                        .notifi_main {
                            text-align: center;
                            padding: 40px 0px;
                        }

                        .notifi_main h2 {
                            border-bottom: 6px solid #F56B55;
                            width: fit-content;
                            margin: 0 auto;
                            padding: 0px 30px;
                        }

                        .notifi_main .descrip_cls {
                            padding: 5px 0px;
                            font-weight: 500;
                            font-size: 21px;
                        }

                        .overlay-bg.t50 {
                            background: rgba(30, 30, 30, .1);
                        }

                        table {
                            width: 100%;
                            margin-top: 10px;
                        }

                        th,
                        td {
                            padding: 10px;
                        }

                        thead {
                            background-color: #F56B55;
                            color: #fff;
                        }

                        tr:nth-child(odd) {
                            background-color: #eee;
                        }

                        .step_no {
                            left: 80px;
                            height: 30px;
                            width: 30px;
                            background-color: #F56B55;
                            border-radius: 50%;
                            display: inline-block;
                            font-size: 18px;
                            text-align: center;
                            color: #fff;
                            margin-right: 10px;
                            position: absolute;
                        }

                        .para_cls p {
                            padding-left: 35px;
                        }

                        .num_marks {
                            text-align: center;
                        }

                        .last_tr {
                            background-color: #F56B55 !important;
                            color: #fff;
                        }

                        .notifi_main_table h2 {

                            width: fit-content;
                            margin: 0 auto;
                            padding: 50px 30px 10px;
                            font-size: 23px;

                        }

                        .para_main_notify {
                            padding: 20px 0px;
                            width: 50%;
                            margin: 0 auto;
                        }

                        #section-services {
                            padding: 0px !important;
                        }
                    </style>
